import React from "react";
export interface IOfferSectionProps {
  title: string;
  Offers: any;
}

const OfferSection: React.FC<IOfferSectionProps> = (props) => {
  return (
    <div>
      <div className="common-head-para">
        <h2>{props.title}</h2>
      </div>
      <div>
        <ul>
          {props.Offers.map((offer: any, i: number) => {
            return (
              <li key={i}>
                <div className=" learnTrade--li">
                  <div className="square-red">
                    <img src={offer.image} alt="White labelled solution" />
                  </div>
                  <div>
                    <h6>{offer.title}</h6>
                    <p>{offer.description}</p>
                  </div>
                </div>
              </li>
            );
          })}
        </ul>
      </div>
    </div>
  );
};

export default OfferSection;
